import { motion } from "framer-motion";

const ROWS = [
  { size: "0-3M", height: "50–62 cm", chest: '16" / 41 cm', length: '12" / 30 cm', weight: "3–6 kg" },
  { size: "3-6M", height: "62–68 cm", chest: '17" / 43 cm', length: '13" / 33 cm', weight: "6–8 kg" },
  { size: "6-9M", height: "68–74 cm", chest: '17.5" / 44 cm', length: '14" / 36 cm', weight: "8–9 kg" },
  { size: "9-12M", height: "74–80 cm", chest: '18" / 46 cm', length: '15" / 38 cm', weight: "9–10 kg" },
  { size: "12-18M", height: "80–86 cm", chest: '19" / 48 cm', length: '16" / 41 cm', weight: "10–11 kg" },
  { size: "18-24M", height: "86–92 cm", chest: '20" / 51 cm', length: '17" / 43 cm', weight: "11–12.5 kg" },
  { size: "1-2Y", height: "80–92 cm", chest: '20" / 51 cm', length: '17" / 43 cm', weight: "9–12 kg" },
  { size: "2-3Y", height: "92–98 cm", chest: '21" / 53 cm', length: '19" / 48 cm', weight: "12–14 kg" },
  { size: "3-4Y", height: "98–104 cm", chest: '22" / 56 cm', length: '21" / 53 cm', weight: "14–16 kg" },
  { size: "4-5Y", height: "104–110 cm", chest: '23" / 58 cm', length: '22" / 56 cm', weight: "16–18 kg" },
];

export default function SizeGuide() {
  return (
    <section id="size-guide" className="py-20 md:py-28" data-testid="size-guide-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mb-12 text-center"
        >
          <p className="font-mono text-xs tracking-[0.35em] uppercase text-sage-dark mb-4">Age & Size Guide</p>
          <h2 className="font-serif font-black text-3xl sm:text-4xl lg:text-5xl text-ink tracking-tight leading-[1.1]">
            Sized for Indian kids,<br />not mannequins.
          </h2>
          <p className="text-charcoal mt-4 max-w-xl mx-auto text-sm sm:text-base">
            Between sizes? Size up — every dress ships with a room-to-grow hem, so it fits for seasons, not weeks.
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="rounded-[2rem] border border-ink/10 overflow-hidden bg-white"
          data-testid="size-guide-table"
        >
          <table className="w-full text-sm">
            <thead className="bg-ink text-cream font-mono text-[10px] uppercase tracking-[0.2em]">
              <tr>
                <th className="p-4 text-left">Size</th>
                <th className="p-4 text-left">Height</th>
                <th className="p-4 text-left">Chest</th>
                <th className="p-4 text-left hidden sm:table-cell">Dress Length</th>
                <th className="p-4 text-left hidden sm:table-cell">Weight</th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map((r, i) => (
                <tr key={r.size} className={i % 2 === 0 ? "bg-cream" : "bg-white"}>
                  <td className="p-4 font-mono font-bold text-terracotta">{r.size}</td>
                  <td className="p-4 text-charcoal">{r.height}</td>
                  <td className="p-4 text-charcoal">{r.chest}</td>
                  <td className="p-4 text-charcoal hidden sm:table-cell">{r.length}</td>
                  <td className="p-4 text-charcoal hidden sm:table-cell">{r.weight}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </motion.div>
      </div>
    </section>
  );
}
